import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import './Labels.css';
import {NavPages} from '../Tools/navPages/NavPages';
import {images} from '../images/images';
import {Loader} from '../Tools/Loader';


const parseName = (origin) => {
	const country = origin.split(',');
	return country[1]
}

const ListView = (props) => {
	return(
		<Link to={props.url}>
			<nav className='listView'>
				<p className='name'>{props.name}</p>
				<p className='date'>{props.date}</p>
				<p className='origin'>{parseName(props.origin)}</p>
			</nav>
		</Link>
	)
}

const GridView = (props) => {
	return(
		<Link to={props.url}>
			<div className="labelGrid">
				<div className='labelName'>
					<h5 className='labelName'>{props.name}<br />{props.origin}</h5>
				</div>
				<div className='labelImage'>
					<img  className="thumbnail" src={props.img} alt={props.name} />
				</div>
			</div>
		</Link>
		)

}


export const Labels = () => {

	const handleSetList = () => {

			document.querySelector('.listViewContainer').style.display = 'block';
			document.querySelector('#listView').classList.add('selected');
			document.querySelector('.gridViewContainer').style.display = 'none';
			document.querySelector('#gridView').classList.remove('selected');
	}

	const handleGridList = () => {

			document.querySelector('#listView').classList.remove('selected');
			document.querySelector('#gridView').classList.add('selected');
			document.querySelector('.listViewContainer').style.display = 'none';
			document.querySelector('.gridViewContainer').style.display = 'grid';
	}

	function screenLoader() {
       const fadeEffect =  setInterval(() => { 
         const preloader = document.querySelector('.preloader')
            if (!preloader.style.opacity) {
              preloader.style.opacity = '1'
            } 
            if (preloader.style.opacity > 0) {
              preloader.style.opacity = '-1'
              setTimeout(() => {preloader.style.display = 'none'}, 100)
            } else {
              clearInterval(fadeEffect)
            }
          }, 200)
      }


	useEffect(() => {
		screenLoader()
	}, [])




	return(
			<section className='labelsContainer'>
				<Loader />

				<header>
					<h1 className='sectionTitle'>Labels</h1>
					<div className='spacer' />
					<aside className='listOrGrid'>
						<p id='listView' onClick={handleSetList}>List</p>
						<span>|</span>
						<p id='gridView' className='selected' onClick={handleGridList}>Grid</p>
					</aside>
				</header>
				<div className='listViewContainer'>
					<ListView url='/profile/analogue_attic' name='Analogue Attic' date='2014' origin='Melbourne, Australia'/>
					<ListView url='/profile/animals_dancing' name='Animals Dancing' date='2009' origin='Melbourne, Australia'/>
					<ListView url='/profile/apparel_music' name='Apparel Music' date='2010' origin='Milan, Italy'/>
					<ListView url='/profile/church' name='Church' date='2013' origin='London, United Kingdom'/>
					<ListView url='/profile/clipp_art' name='Clipp.Art' date='2018' origin='Melbourne, Australia'/>
					<ListView url='/profile/coastal_haze' name='Coastal Haze' date='2016' origin='London, United Kingdom'/>
					<ListView url='/profile/delusions_of_grandeur' name='Delusions of Grandeur' date='2009' origin='London, United Kingdom'/>
					<ListView url='/profile/late_night_tales' name='Late Night Tales' date='2001' origin='London, United Kingdom'/>
					<ListView url='/profile/lets_play_house' name="Let's Play House" date='2011' origin='New York, USA'/>
					<ListView url='/profile/lobster_theremin' name='Lobster Theremin' date='2013' origin='London, United Kingdom'/>
					<ListView url='/profile/shall_not_fade' name='Shall Not Fade' date='2015' origin='Bristol, United Kingdom'/>
					<ListView url='/profile/sloth_boogie' name='Sloth Boogie' date='2017' origin='London, United Kingdom'/>
				</div>
				<div className='gridViewContainer'>
					<GridView url='/profile/analogue_attic' name='Analogue Attic' date='2014' origin='Melbourne, Australia' img={images.analogueAttic.logo}/>
					<GridView url='/profile/animals_dancing' name='Animals Dancing' date='2009' origin='Melbourne, Australia' img={images.animalsDancing.logo}/>
					<GridView url='/profile/apparel_music' name='Apparel Music' date='2010' origin='Milan, Italy' img={images.apparelMusic.logo}/>
					<GridView url='/profile/church' name='Church' date='2013' origin='London, United Kingdom' img={images.church.logo}/>
					<GridView url='/profile/clipp_art' name='Clipp.Art' date='2018' origin='Melbourne, Australia' img={images.clippArt.logo}/>
					<GridView url='/profile/coastal_haze' name='Coastal Haze' date='2016' origin='London, United Kingdom' img={images.coastalHaze.logo}/>
					<GridView url='/profile/delusions_of_grandeur' name='Delusions of Grandeur' date='2009' origin='London, United Kingdom' img={images.delusionsOfGrandeur.logo}/>
					<GridView url='/profile/late_night_tales' name='Late Night Tales' date='2001' origin='London, United Kingdom' img={images.lateNightTales.logo}/>
					<GridView url='/profile/lets_play_house' name="Let's Play House" date='2011' origin='New York, USA' img={images.letsPlayHouse.logo}/>
					<GridView url='/profile/lobster_theremin' name='Lobster Theremin' date='2013' origin='London, United Kingdom' img={images.lobsterTheremin.logo}/>
					<GridView url='/profile/shall_not_fade' name='Shall Not Fade' date='2015' origin='Bristol, United Kingdom' img={images.shallNotFade.logo}/>
					<GridView url='/profile/sloth_boogie' name='Sloth Boogie' date='2017' origin='London, United Kingdom' img={images.slothBoogie.logo}/>
				</div>
				<hr className='space contentSeperator'/>
				<NavPages />
			</section>
		)
};